import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import '../css/DcrMonthlyPOBStockistSlabEmployeeReport.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BASE_URL } from "../config";

const DcrMonthlyPOBStockistSlabEmployeeReport = () => {
    // const navigate = useNavigate(); 
    // const location = useLocation();
    const [states, setStates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("All");
    const [selectedEmployee, setSelectedEmployee] = useState("All");
    // const [retailerType, setRetailerType] = useState("All");
    // const [activeStatus, setActiveStatus] = useState("All");
    const [productiveGT, setProductiveGT] = useState();
    const today = new Date().toISOString().split('T')[0];
    const startOfMonth = new Date();
    startOfMonth.setDate(1);
    const startDateStr = startOfMonth.toISOString().split('T')[0];

    const [fromDate, setFromDate] = useState(startDateStr);
    const [toDate, setToDate] = useState(today);
    const [tableData, setTableData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [errors, setErrors] = useState({
        state: false,
        employee: false
    });


    
    // 👈 this will run once on mount (initial render)
    
    


    const fetchEmployees = useCallback(async (stateId, divisionName) => {
        if (!stateId) return;
        try {
        let url = `${BASE_URL}/api/employees?state_id=${stateId}`;
        if (divisionName && divisionName !== "All") {
            url += `&division=${encodeURIComponent(divisionName)}`;
        }
        const res = await axios.get(url);
        setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...res.data]);
        setSelectedEmployee("All");
        } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployees([]);
        }
    }, []);

    useEffect(() => {
        const fetchStates = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/states`);
            setStates(response.data);
        } catch (err) {
            console.error("Error fetching states:", err);
        }
        };
        fetchStates();
    }, []);

    const handleStateChange = async (stateId) => {
        setSelectedState(stateId);
        setSelectedDivision("All");
        setSelectedEmployee("All");

        try {
        const divisionRes = await axios.get(
            `${BASE_URL}/api/divisions?state_id=${stateId}`
        );
        setDivisions(divisionRes.data);
        } catch (err) {
        console.error("Error loading divisions", err);
        }

        fetchEmployees(stateId, "All");
    };

    const handleDivisionChange = async (divisionId) => {
        setSelectedDivision(divisionId);
        setSelectedEmployee("All"); // Reset employee selection
        
        try {
            let url = `${BASE_URL}/api/employees?state_id=${selectedState}`;
            if (divisionId && divisionId !== "All") {
                const division = divisions.find(d => d.id == divisionId);
                if (division) {
                    url += `&division=${encodeURIComponent(division.name)}`;
                }
            }
            
            const res = await axios.get(url);
            setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...res.data]);
        } catch (err) {
            console.error("Error fetching employees:", err);
            setEmployees([]);
        }
    };
    const handleGoClick = async () => {
        const newErrors = {
            state: !selectedState,  // Only state is required
            employee: false        // Employee is optional
        };
        
        setErrors(newErrors);
        
        if (newErrors.state) {
            return;
        }
        
        setShowTable(true);
        try {
            let url = `${BASE_URL}/api/reports/dcrmonthlypobstockistslabemployeereport?state_id=${selectedState}`;
            
            // Add division filter if selected (not "All")
            if (selectedDivision && selectedDivision !== "All") {
                // Get the division name from the divisions array
                const division = divisions.find(d => d.id == selectedDivision);
                if (division) {
                    url += `&division=${encodeURIComponent(division.name)}`;
                }
            }
            
            // Add employee filter if selected (not "All")
            if (selectedEmployee && selectedEmployee !== "All") {
                url += `&employee_id=${selectedEmployee}`;
            }
            
            // Add other filters
            if (fromDate) url += `&from_date=${fromDate}`;
            if (toDate) url += `&to_date=${toDate}`;
            if (productiveGT) url += `&productive_gt=${productiveGT}`;
            
            const response = await axios.get(url);
            console.log("API Response", response)
            setReportData(response.data);

        } catch (error) {
            console.error("Error fetching report data:", error);
            setReportData([]);
        }
    };


    // Add this useEffect at the top of your component
    
      
      

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate().toString().padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

  return (
    <div className="DcrMonthlyPOBStockistSlabEmployeeReport-main-container">
      <div className="DcrMonthlyPOBStockistSlabEmployeeReport-filter-container">
        <div className="DcrMonthlyPOBStockistSlabEmployeeReport-title-container">
          <h2 className="DcrMonthlyPOBStockistSlabEmployeeReport-title">Visit / Support</h2>
          </div>
          <div className="DcrMonthlyPOBStockistSlabEmployeeReport-row1">
                <label className="DcrMonthlyPOBStockistSlabEmployeeReport-label">State</label>
                <select className={`DcrMonthlyPOBStockistSlabEmployeeReport-dropdown ${errors.state ? 'error-border' : ''}`} 
                 onChange={(e) => {
                    handleStateChange(e.target.value);
                    setErrors({...errors, state: false});
                  }} value={selectedState} required>
                    <option value="">Select State</option>
                    {states.map((state) => (
                    <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                </select>
                <label className="DcrMonthlyPOBStockistSlabEmployeeReport-label">Division</label>
                <select className="DcrMonthlyPOBStockistSlabEmployeeReport-dropdown" onChange={(e) => handleDivisionChange(e.target.value)} value={selectedDivision}>
                    <option value="All">All</option>
                    {divisions.map((div) => (
                    <option key={div.id} value={div.id}>{div.name}</option>
                    ))}
                </select>
            </div>
            <div className="DcrMonthlyPOBStockistSlabEmployeeReport-row2">
              
             
                    <label className="DcrMonthlyPOBStockistSlabEmployeeReport-label">Start-Date:</label>
                    <input className="DcrMonthlyPOBStockistSlabEmployeeReport-dropdown" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />

                    
                    <label className="DcrMonthlyPOBStockistSlabEmployeeReport-label">End-Date:</label>
                    <input className="DcrMonthlyPOBStockistSlabEmployeeReport-dropdown" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    
            </div>


          
          <div className="DcrMonthlyPOBStockistSlabEmployeeReport-go-button-container">
            <button className="DcrMonthlyPOBStockistSlabEmployeeReport-gobutton" onClick={handleGoClick}>GO</button>
          </div>

        </div>
       

        {showTable && (
            <>
          <div className="DcrMonthlyPOBStockistSlabEmployeeReport-table-section">
          <div className="DcrMonthlyPOBStockistSlabEmployeeReport-title3-container">
          <h2 className="DcrMonthlyPOBStockistSlabEmployeeReport-table-title">
        {`POB (${states.find(s => s.id == selectedState)?.name || selectedState}) - ${selectedDivision === "All" ? "All" : divisions.find(d => d.id == selectedDivision)?.name || ""} From ${formatDate(fromDate)} to ${formatDate(toDate)}`}
            </h2>
            </div>
            <div className="DcrMonthlyPOBStockistSlabEmployeeReport-table-wrapper">
              <table className="DcrMonthlyPOBStockistSlabEmployeeReport-table">
              <thead className="text-white">
              <tr>
                        <th>S.No</th>
                        <th>Emp ID</th>
                        <th>Employee</th>
                        <th>Stockist</th>
                        <th>Mobile</th>
                        <th>HQ</th>
                        <th>Address</th>
                        <th>GSTIN</th>
                        <th>Visit</th>
                        <th>POB</th>
                    </tr>
                    </thead>

                    <tbody>
                    {reportData.map((item, index) => (
                        <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.emp_id || "N/A"}</td>
                        <td>{item.employee || ""}</td>
                        <td>{item.stockist || ""}</td>
                        <td>{item.mobile || ""}</td>
                        <td>{item.hq || ""}</td>
                        <td>{item.address || ""}</td>
                        <td>{item.gstin || ""}</td>
                        <td>{item.visit}</td>
                        <td>{item.total_pob.toFixed(2)}</td>
                        </tr>
                    ))}
                    </tbody>


              </table>
            </div>
          </div>
        

        <div className="DcrMonthlyPOBStockistSlabEmployeeReport-button-container">
          <button className="DcrMonthlyPOBStockistSlabEmployeeReport-printbutton">Print</button>
          <button className="DcrMonthlyPOBStockistSlabEmployeeReport-exportbutton">Export to Excel</button>
        </div>
        </>
      )}
    </div>
  );
};

export default DcrMonthlyPOBStockistSlabEmployeeReport;
